import React, { FC } from 'react';
import CreateForm from '../../../../../../components/ui-component/form-component/create-form/CreateForm';
import { useApplication } from '../../../../../../context/ApplicationContext';
import { FORM_FIELDS_TYPES, PLATZHALTER_TEXT } from '../../../../../../lib/constants/constant';
import { FormStrucItem } from '../../../../../../lib/types/types';
import { getFormStrucComponentTable } from '../../../../../../utils/formStruc';
import ApplicationHeading from '../../../application-heading/ApplicationHeading';

// import schemas
import Schema from '../../../../../../lib/paths/zwischenbericht_FULL_Paths.json';
const P = Schema.attributes;

const Oeffentlichkeitsarbeit: FC<{}> = () => {
	const { application, setApplicationProperty, readOnly } = useApplication();
	return (
		<>
			<ApplicationHeading title='Öffentlichkeitsarbeit' description={PLATZHALTER_TEXT} />
			<CreateForm formStruc={formStruc()} formValues={application} updateFormValuesFunc={setApplicationProperty} readOnly={readOnly} />
		</>
	);
};
export default Oeffentlichkeitsarbeit;

const formStruc = () => {
	let struc: FormStrucItem[] = [
		{
			fields: [{ ...P.Oeffentlichkeitsarbeit_Publikationen, type: FORM_FIELDS_TYPES.componentTable, tableLabel: 'Publikationen' }],
			userProps: { columnToDivide: 1 },
		},
		{
			fields: [{ ...P.Oeffentlichkeitsarbeit_Veroeffentlichungen, type: FORM_FIELDS_TYPES.componentTable, tableLabel: 'Veröffentlichungen' }],
			userProps: { columnToDivide: 1 },
		},
		{
			fields: [{ ...P.Oeffentlichkeitsarbeit_Vortraege, type: FORM_FIELDS_TYPES.componentTable, tableLabel: 'Vorträge' }],
			userProps: { columnToDivide: 1 },
		},
		{
			fields: [
				{ ...P.Oeffentlichkeitsarbeit_Ausstellungen_Auf_Messen, type: FORM_FIELDS_TYPES.componentTable, tableLabel: 'Ausstellungen auf Messen' },
			],
			userProps: { columnToDivide: 1 },
		},
	];
	return struc;
};

export function getFormStrucOeffentlichkeitsarbeit(application: any): FormStrucItem[] {
	const formStrucOeffentlichPub = getFormStrucComponentTable(application, formStruc());
	return formStrucOeffentlichPub;
}
